import { setStepName, setCloseTimeout } from '.';
import { MILLISECONDS_IN_A_SEC } from '../constants';
export const autoCloseInSeconds = (sec) => (dispatch) => {
    const closeTimeout = setTimeout(() => {
        dispatch(setStepName(null));
    }, sec * MILLISECONDS_IN_A_SEC);
    dispatch(setCloseTimeout(closeTimeout));
};
